export enum CounterActions {
  INCREMENT = 'INCREMENT',
  INCREMENT_BY = 'INCREMENT_BY',
  DECREMENT = 'DECREMENT',
  RESET = 'RESET',
}

export const increment = () => ({ type: CounterActions.INCREMENT });
export const decrement = () => ({ type: CounterActions.DECREMENT });
export const incrementBy = (payload: number) => ({
  type: CounterActions.INCREMENT_BY,
  payload,
});
export const reset = () => ({ type: CounterActions.RESET });
